import React from 'react'

import { Card as BaseCard } from '@chilecompra/react-kit/components'
import { Grid as BaseGrid, Divider as DividerBase, styled } from '@mui/material'

export const Card = styled(({ textAlign, ...props }) => <BaseCard {...props} />)`
  &.MuiPaper-root * {
    text-align: ${props => props.textAlign};
  }
`

export const Root = styled('div')`
  width: 100%;
`

export const Grid = styled(BaseGrid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
  background-color: ${props => props.background && props.theme.palette.green[95]};
  border: ${props => props.border && '1px solid'};
  border-color: ${props => props.border && props.theme.palette.green[75]};
`

export const LinkAddProduct = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  letter-spacing: 0;
  line-height: 23px;
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  width: 82px;
`

export const AddProduct = styled('div')`
  color: ${props => props.theme.palette.green[50]};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  letter-spacing: 0;
  line-height: 21px;
`

export const LineJump = styled('br')``
export const Divider = styled(DividerBase)``
